import { api } from './api'
import { Icon } from './icon'

class BuildSettings {
  run (elem) {
    var settings = this.default()
    var specificSettings = this.specificSettings(elem, settings)

    return specificSettings
  }

  default () {
    return {
      placeholder: 'Select...',
      hidePlaceholder: true,
      closeAfterSelect: true,
      duplicates: true,
      plugins: {
        remove_button: {
          title: 'Remove this item',
        },
      },
    }
  }

  specificSettings (elem, settings) {
    this.userIdentitiesSettings(elem, settings)
    this.newBusinessSettings(elem, settings)
    this.selectAccountSettings(elem, settings)
    this.selectComplianceSettings(elem, settings)
    this.resourceItemSettings(elem, settings)
    this.accountServiceAdvisor(elem, settings)
    this.complianceSubmissionAdvisor(elem, settings)
    this.clientName(elem, settings)
    this.accountServiceAccountNumber(elem, settings)
    this.complianceAccountNumber(elem, settings)
    this.submissionSearch(elem, settings)
    this.resourcePermissionSettings(elem, settings)
    this.accountSelectSettings(elem, settings)
    this.primaryAdvisorSettings(elem, settings)

    return settings
  }

  accountServiceAdvisor(elem, settings) {
    if (elem.name === 'account_service_submission[rep_code_attributes][value]') {
      var accountServiceSubmissionSettings = {
        placeholder: 'Select Advisor...',
        itemClass: 'item pl-1 resource-item text-base background-none',
        plugins: {},
      }

      Object.assign(settings, accountServiceSubmissionSettings)
    }
  }

  accountSelectSettings (elem, settings) {
    if (elem.name === 'select_account') {
      var accountSelectionSettings = {
        maxItems: 1,
        hidePlaceholder: false,
        plugins: ['dropdown_input'],
      }

      Object.assign(settings, accountSelectionSettings)
    }
  }

  complianceSubmissionAdvisor (elem, settings) {
    if (elem.dataset.complianceAdvisor) {
      var complianceSubmissionSettings = {
        placeholder: 'Select Rep Code...',
        itemClass: 'item pl-1 resource-item text-base background-none',
        plugins: {},
        onChange (value) {
          window.app.submissionViewManagement.removeOutdatedData(value)
        },
      }

      Object.assign(settings, complianceSubmissionSettings)
    }
  }

  userIdentitiesSettings (elem, settings) {
    if (elem.name === 'user[identity_ids][]') {
      var onChangeSettings = {
        onChange () {
          new window.app.identityTracker().updateIdentityOptions()
        },
      }

      Object.assign(settings, onChangeSettings)
    }
  }

  newBusinessSettings (elem, settings) {
    if (elem.name === 'submission_container[select_account][]') {
      var onChangeSettings = {
        sortField: {
          field: 'text',
          direction: 'desc',
        },
      }

      Object.assign(settings, onChangeSettings)
    }
  }

  selectAccountSettings (elem, settings) {
    if (elem.name === 'select_account') {
      var parentDropdownSettings = {
        onInitialize: function () {
          this.dropdown.classList.add('ts-static')
        },
        itemClass: 'item pl-1 resource-item text-base background-none',
        dropdownParent: 'body',
        placeholder: 'Select Account...',
        plugins: {},
      }

      Object.assign(settings, parentDropdownSettings)
    }
  }

  selectComplianceSettings (elem, settings) {
    if (elem.name === 'select_compliance_form') {
      var parentDropdownSettings = {
        itemClass: 'item pl-1 resource-item text-base background-none',
        placeholder: 'Select Form/Instructions...',
        plugins: {},
        sortField: {
          field: 'text',
          direction: 'asc',
        },
      }

      Object.assign(settings, parentDropdownSettings)
    }
  }

  resourcePermissionSettings (elem, settings) {
    if (elem.dataset.permissionField === 'true') {
      var resourcePermissionSettings = {
        placeholder: 'All',
      }
      Object.assign(settings, resourcePermissionSettings)
    }
  }

  resourceItemSettings (elem, settings) {

    const resourceTypes = [
      'resource_subtopic[resource_topic_id]',
      'resource_item[resource_topic_id]',
      'resource_item[resource_item_format_id]',
      'resource_item[resource_subtopic_id]',
    ]

    if (resourceTypes.includes(elem.name)) {
      var resourceItemSettings = {
        itemClass: 'item resource-item text-base background-none',
        maxItems: 1,
        hidePlaceholder: false,
        plugins: ['dropdown_input'],
      }

      Object.assign(settings, resourceItemSettings)
    }
  }

  clientName (elem, settings) {
    if (elem.name === 'submission_container[submissions_attributes][0][form_fields][client_name]') {
      var clientNameSettings = {
        create: true,
        itemClass: 'item pl-1 resource-item text-base background-none',
        placeholder: 'Select Client...',
        plugins: {},
        onChange (value) {
          if (!value) { return }

          const repCode = this.options[value].repCode

          window.app.submissionViewManagement.removeOutdatedManager(repCode)
        },
      }

      Object.assign(settings, clientNameSettings)
    }
  }

  accountServiceAccountNumber (elem, settings) {
    if (elem.name === 'account_service_submission[form_fields][account_number]') {
      var accountNumberSettings = {
        create: true,
        itemClass: 'item pl-1 resource-item text-base background-none',
        placeholder: 'Account Number...',
        plugins: {},
      }

      Object.assign(settings, accountNumberSettings)
    }
  }

  complianceAccountNumber (elem, settings) {
    if (elem.name === 'submission_container[submissions_attributes][0][form_fields][account_number]') {
      var accountNumberSettings = {
        create: true,
        itemClass: 'item pl-1 resource-item text-base background-none',
        placeholder: 'Select Account...',
        plugins: {}
      }

      Object.assign(settings, accountNumberSettings)
    }
  }

  primaryAdvisorSettings(elem, settings) {
    if (elem.name === 'submission_container[submissions_attributes][0][primary_advisor]') {
      var primaryAdvisorSettings = {
        create: true,
        itemClass: 'item pl-1 resource-item text-base background-none',
      }
    }

    Object.assign(settings, primaryAdvisorSettings)
  }

  get submissionsIcon() {
    return new Icon('icon-submissions', { classes: 'box-content p-2 text-2xl text-whitelabel-400' }).asString()
  }

  submissionSearch(elem, settings) {
    if (elem.id === 'submission-attachment-container') {
      var submissionValue = document.querySelector('[name="submission_id"]')

      if (submissionValue) {
        var submissionId = submissionValue.value
      }

      var resourceItemSettings = {
        optionClass: 'p-2',
        valueField: 'id',
        labelField: 'category',
        placeholder: 'Select Submissions...',
        // This corresponds to the serialized data found in SubmissionSerializer
        // if you want to add more fields for the search, you'll have to add them
        // to the serializer as well
        // - app/frontend/build-settings.js
        // - app/models/submission.rb
        // - app/serializers/submission_serializer.rb
        searchField: [
          'id',
          'account_number',
          'category',
          'rep_code_value',
          'description',
          'created_at',
          'user_name',
          'legacy_manager_code',
          'legacy_account_number',
        ],
        load: function (query, callback) {
          var ids = []
          var submissions = document.getElementsByClassName('submission-selection-container')

          Array.from(submissions).forEach($submission => {
            ids.push($submission.id)
          })

          if (submissionId) {
            ids.push(submissionId)
          }

          api.submissions
            .search({ ids, query })
            .then(res => res.json)
            .then(json => callback(json))
            .catch(() => callback())
        },
        render: {
          option: (item, escape) => {
            return `<div class="flex items-center m-2 rounded group-hover">
              <div class="bg-white rounded-full submission-svg-background">
                ${this.submissionsIcon}
                <div id="submission-id-${item.id}" class="sr-only">${escape(item.submission_id)}</div>
              </div>
              <div class="ml-2">
                <div>
                  ${escape(item.description || item.category)}
                  <span class="text-xs text-gray-400 italic">by ${escape(item.user_name)}</span>
                </div>
                <div>
                  <p class="text-xs">
                    Submitted
                    <b class="text-whitelabel-400">${escape(item.created_at)}</b> in
                    <b class="text-whitelabel-400">${escape(item.category)}</b>
                  </p>
                </div>
              </div>
            </div>`
          },
        },
      }
    }

    Object.assign(settings, resourceItemSettings)
  }
}

export default BuildSettings
